import clsx from 'clsx';
import { FunctionComponent } from 'react';

import { PoweredByAssemblyBadge } from 'src/features/badge/PoweredByAssemblyBadge';

interface Props {
  isAuthScreen: boolean;
  isPreview: boolean;
}

// The corner variant is absolutely positioned, so this zero-size anchor decides
// which corner it lands in: the viewport on a live checkout, the preview frame
// in the dashboard. z-20 keeps it above the payment column's z-10 white panel.
// The preview is a mock checkout, so its badge must not open the link.
export const CheckoutCornerBadge: FunctionComponent<Props> = ({
  isAuthScreen,
  isPreview,
}) => (
  <div
    className={clsx('bottom-0 right-0 z-20', {
      'absolute pointer-events-none': isPreview,
      fixed: !isPreview,
    })}
  >
    <PoweredByAssemblyBadge
      isAuthScreen={isAuthScreen}
      placement="invoice"
      variant="corner"
    />
  </div>
);
